<template>
    <div class="h-100 d-flex flex-column">
        <div class="row justify-content-center align-items-center px-2">
            <div class="col-md-6 login-box">
                <div class="text-center mb-2">
                    <TheLogo id="logo" class="mb-4"/>
                    <h5 class="text-center text-dark">{{ title }}</h5>
                    <p class="text-center">{{ subtitle }}</p>
                </div>
                <slot></slot>  
            </div>
        </div>
        <footer class="text-center">
            <a target="_blank" href="https://yo.sale/termos-de-uso">Termos de uso</a>
            <a target="_blank" href="https://yo.sale/politica-de-privacidade">Política de privacidade</a>
            <a class="copyright_fullsale">© {{ currentYear }} yosale.</a>
        </footer>
    </div>
</template>

<script>

export default {
    props: [
        'title', 'subtitle'
    ],
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style scoped>
.row {
    width: 100%;
    height: 100%;
    margin: 0;
    color: #595959;
}

:slotted(p) {
    font-size: 14px;
}

.login-box {
    width: 500px;
    padding-bottom: 40px
}

#logo {
    width: 150px;
    padding: 20px 0px;
}

a {
    color: #28bc6d;
    text-decoration: none;
    font-size: 14px;
}

a:hover {
    color: #0056b3;
    text-decoration: underline;
}

:deep(a:hover) {
    text-decoration: underline !important;
}

footer {
    padding-top: 20px;
    padding-bottom: 5px;
    margin-bottom: 1rem;
}

footer a {
    font-size: 13px;
    color: #949494 !important;
    margin: 0 10px;
}

.copyright_fullsale:hover{
    text-decoration: none !important;;
}
</style>